<template>
  <div>
    <div class="uk-grid-medium" uk-grid>
      <div class="uk-width-5-5">

        <div class="d-flex">
          <nav id="breadcrumbs" class="mb-3">
            <ul>
              <li><a href="#"> <i class="uil-home-alt"></i> </a></li>
              <li>{{$t('question.questions')}}</li>
              <li>{{$t('question.add')}}</li>
            </ul>
          </nav>
        </div>

        <div class="card">
          <div v-for="error in formErrors" v-if="formErrors" class="uk-alert-danger" uk-alert>
            <a class="uk-alert-close" uk-close></a>
            <p style="color:red;">
              <i class="uil-exclamation-triangle"></i> {{ error }} </p>
          </div>
          <div v-if="successMessage" class="uk-alert-success" uk-alert>
            <a class="uk-alert-close" uk-close></a>
            <p style="color:green;">
              <i class="uil-exclamation-triangle"></i> {{ successMessage }} </p>
          </div>
        </div>

        <div class="card mt-4">
          <div class="card-body">
            <h4><i class="uil-question-circle"></i> {{$t('question.add')}}</h4>
            <hr>
            <div class="row">
              <div class="col-12" v-if="loading">
                <default-loading></default-loading>
              </div>
              <div class="col-xl-9 m-auto" v-else>
                <div class="form-group row mb-3">
                  <label class="col-md-3 col-form-label" for="type">{{$t('question.attributes.q_type')}} <span class="required">*</span></label>
                  <div class="col-md-9">
                    <select @change="formTypeControl" class="selectpicker" v-model="form.type" id="type">
                      <option v-for="type in question_types" :value="type.id"><i :class="type.icon"></i> {{type.name}}</option>
                    </select>
                  </div>
                </div>

                <div class="form-group row mb-3" v-if="form.type == 3 || form.type == 5">
                  <label class="col-md-3 col-form-label">{{$t('question.attributes.image')}} <span class="required">*</span></label>
                  <div class="col-md-9">
                    <div class="uploadOuter">
                      <label for="questionFileUpload" class="btn btn-info"><i class="uil-upload"></i>{{$t('general.upload')}}</label>
                      <strong>{{$t('general.or')}}</strong>
                      <span class="dragBox">
                          <i class="icon-feather-file-plus"></i>
                          {{$t('general.doc_file_drag_drop')}}
                          <input accept="image/*" type="file" @change="dragNdrop($event)" id="questionFileUpload">
                        </span>
                    </div>
                    <div v-if="form.media_is_url" id="preview" class="filePreview">
                      <img width="250" :src="form.media" alt="">
                    </div>
                    <div v-else id="preview" class="filePreview" v-html="preview"></div>
                  </div>
                </div>

                <div class="form-group row mb-3" v-if="form.type == 7">
                  <label class="col-md-3 col-form-label">{{$t('general.audio_file')}} <span class="required">*</span></label>
                  <div class="col-md-9">
                    <div class="uploadOuter">
                      <label for="uploadFile" class="btn btn-info"><i class="uil-upload"></i>{{$t('general.upload')}}</label>
                      <strong>{{$t('general.or')}}</strong>
                      <span class="dragBox">
                          <i class="icon-feather-file-plus"></i>
                          {{$t('general.audio_file_drag_drop')}}
                          <input accept="audio/*" type="file" @change="dragNdropAudio($event)" id="uploadFile">
                        </span>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="row" v-if="form.media_is_url">
                      <div class="col-lg-3"></div>
                      <div class="col-lg-9">
                        <div class="text-center" id="preview">
                          <audio controls>
                            <source :src="form.media" type="audio/mpeg">
                          </audio>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div v-if="audioPreview" id="preview" v-html="audioPreview"></div>
                    </div>
                  </div>
                </div>

                <div class="form-group row mb-3" v-if="form.type == 8">
                  <label class="col-md-3 col-form-label">{{$t('general.video_file')}} <span class="required">*</span></label>
                  <div class="col-md-9">
                    <div class="uploadOuter">
                      <label for="uploadFile" class="btn btn-info"><i class="uil-upload"></i>{{$t('general.upload')}}</label>
                      <strong>{{$t('general.or')}}</strong>
                      <span class="dragBox">
                          <i class="icon-feather-file-plus"></i>
                          {{$t('general.video_file_drag_drop')}}
                          <input accept="video/*" type="file" @change="dragNdropVideo($event)" id="uploadFile">
                        </span>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="row" v-if="form.media_is_url">
                      <div class="col-lg-3"></div>
                      <div class="col-lg-9">
                        <div class="text-center" id="preview">
                          <video width="320" height="240" controls>
                            <source :src="form.media" type="video/mp4">
                          </video>
                        </div>
                      </div>
                    </div>
                    <div v-if="videoPreview" id="preview" v-html="videoPreview"></div>
                  </div>
                </div>

                <div class="form-group row mb-3">
                  <label class="col-md-3 col-form-label" for="question_text">{{$t('question.attributes.text')}} <span class="required">*</span></label>
                  <div class="col-md-9">
                    <textarea name="question_text" id="question_text" v-model="form.text" :placeholder="$t('question.attributes.text')" class="form-control"></textarea>
                  </div>
                </div>

                <div class="form-group row mb-3" v-if="form.type == 6">
                  <label class="col-md-3 col-form-label" for="answer_text">{{ $t('question.attributes.answer') }}<span class="required">*</span></label>
                  <div class="col-md-9">
                    <textarea name="question_text" v-model="form.answers[0].name" id="answer_text" :placeholder="$t('question.attributes.answer')" class="form-control"></textarea>
                  </div>
                </div>

                <div class="form-group row mb-3" v-if="form.type != 6">
                  <label class="col-md-3 col-form-label" for="replies">{{$t('question.attributes.answer_options')}} <span class="required">*</span></label>
                  <div class="col-md-9">
                    <table id="myTable" class=" table order-list">
                      <thead>
                      <tr>
                        <td>{{$t('question.attributes.answer_text')}}</td>
                        <td class="text-center">{{ $t('general.status') }}</td>
                        <td class="text-right">{{ $t('general.action') }}</td>
                      </tr>
                      </thead>

                      <tbody v-if="formattedAnswers">
                      <tr v-for="(item, index) in form.answers">
                        <td class="col-sm-4">
                          <div class="form-group row mb-3" v-if="form.type == 4 || form.type == 5">
                            <div class="col-md-12">
                              <div class="uploadOuter">
                                <label :for="'uploadFileReply'+index" class="btn btn-info"><i class="uil-upload"></i>{{ $t('general.upload') }}</label>
                                <br>
                                <strong>{{$t('general.or')}}</strong>
                                <span class="dragBox">
                                    <i class="icon-feather-file-plus"></i>
                                    {{$t('general.doc_file_drag_drop')}}
                                    <input accept="image/*" type="file" :data-index="index" ref="replies" @change="dragNdropReply($event)" :id="'uploadFileReply'+index">
                                  </span>
                              </div>
                              <div class="row">
                                <div v-if="item.question_answer_media" class="col-lg-12">
                                  <div id="preview">
                                    <img width="250" :src="item.question_answer_media" alt="">
                                  </div>
                                </div>
                                <div v-else class="col-lg-12">
                                  <div id="preview" :class="'preview_' + index" v-html="previewReply[index]"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <input v-if="questionTypeCheck(form.type)" type="text" required name="reply_text" v-model="item.name" class="form-control" />
                        </td>
                        <td class="col-sm-4">
                          <div class="d-flex align-content-center justify-content-center table-vertical-center align-items-center">
                            <toggle-button
                                :width="80"
                                v-model="item.answer"
                                color="#ae71ff"
                                :labels="{checked: $t('question.attributes.true'), unchecked: $t('question.attributes.false')}"
                            />
                          </div>
                        </td>
                        <td class="col-sm-4">
                          <div class="actions mr-2 float-right">
                            <a href="javascript:void(0)" @click="removeRow(index)" :uk-tooltip="$t('general.remove_from_list')" class="btn btn-icon btn-hover btn-lg btn-circle" title="" aria-expanded="false">
                              <i class="uil-times-circle text-danger"></i>
                            </a>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr>
                        <td colspan="5" style="text-align: left;">
                          <input @click="addRow" type="button" class="btn btn-lg btn-outline-primary" id="addrow" :value="$t('general.add')" />
                        </td>
                      </tr>
                      <tr>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <div class="uk-card-footer float-right pb-0 pr-0">
                  <button @click="$router.push({'name': 'company.questions.list'})" class="uk-button uk-button-default small mr-3">{{ $t('general.back') }}</button>
                  <button class="uk-button uk-button-primary small" type="button" @click="saveForm();"><i class="icon-feather-arrow-right"></i>
                    {{ $t('general.save') }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import module, { BASE_URL, GET_ITEM, ITEM, MODULE_NAME, ERROR, UPDATE_ITEM, GET_QUESTION_TYPES, QUESTION_TYPES, QUESTION_TYPE_URL, LOADING } from "@/core/services/store/question.module";
import store from "@/core/services";
import DefaultLoading from "@/view/components/loading/DefaultLoading";

export default {
  name: "QuestionEdit",
  components: {DefaultLoading},
  beforeCreate () {
    function registerStoreModule (moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule)
      }
    }
    registerStoreModule(MODULE_NAME, module)
  },
  data() {
    return {
      preview : null,
      audioPreview : null,
      videoPreview : null,
      previewReply: [],
      form : {
        media_is_url: true,
        type : 1,
        text : '',
        media : '',
        answers : [],
      },
      formErrors : [],
      successMessage : null,
      answer_type : null,
    }
  },
  computed: {
    question_types: {
      get() {
        return store.getters[MODULE_NAME + '/' + QUESTION_TYPES]
      },
      set(value) {
      }
    },
    item: {
      get() {
        return store.getters[MODULE_NAME + '/' + ITEM]
      },
      set(value) {
      }
    },
    errors: {
      get() {
        return store.getters[MODULE_NAME + '/' + ERROR]
      },
      set(value) {
      }
    },
    loading() {
        return store.getters[MODULE_NAME + '/' + LOADING]
    },
    formattedAnswers() {
      let self = this;
      if (self.item === null || !self.item.hasOwnProperty('question_answers')) return [];
      let result = [];

      self.form.type = self.item.question_type_id;
      self.form.text = self.item.text;
      self.form.media = self.item.question_media
      self.form.media_is_url = true;

      self.item.question_answers.forEach(item => {

        self.answer_type = item.type;

        result.push({
          id : item.id,
          name : item.text,
          media : item.media,
          question_answer_media : item.question_answer_media,
          answer : (item.is_true) ? true : false
        });
      })

      self.form.answers = result;

      return result;
    },
  },
  methods: {
    saveForm(){
      let self = this;
      let form = self.form;

      if(form.text.length == 0){
        self.formErrors.push(self.$t('question.required.text'));
        self.scrollToTop()
        return false;
      }

      if(form.answers.length == 0){
        self.formErrors.push(self.$t('question.required.answers'));
        self.scrollToTop()
        return false;
      }

      if (self.answer_type == "text"){
        let error = null;
        let is_true = null;
        form.answers.forEach(item => {
          if (item.name.length == 0){
            self.formErrors.push(self.$t('question.required.answer_name'));
            self.scrollToTop()
            error = true;
          }
          if (item.answer){
            is_true = true;
          }
        });
        if (is_true === null){
          self.formErrors.push(self.$t('question.required.answer_is_true'));
          self.scrollToTop()
          error = true;
        }
        if (error){
          return false;
        }
      }

      let answer_true_count = 0;
      form.answers.forEach(item => {
        if(item.answer){
          answer_true_count++;
        }
      });

      if (form.type == 1){
        if (answer_true_count == 0){
          self.formErrors.push(self.$t('question.required.true_count_only_one'));
          self.scrollToTop()
          return false;
        }
      }
      if (answer_true_count > 1){
        self.formErrors.push(self.$t('question.required.true_count'));
        self.scrollToTop()
        return false;
      }

      let formData = new FormData();
      let form_answers = JSON.stringify(form.answers);

      formData.append('question_type_id', form.type);
      formData.append('text', form.text);
      formData.append('answers', form_answers);
      formData.append('question',this.$route.params.id);

      if (!self.form.media_is_url){
        formData.append('media', form.media);
      }

      if (form.type == 4 || form.type == 5){
        $(form.answers).each(function (index,val) {
          formData.append('replyImages[]', val.media)
        })
      }

      store.dispatch(MODULE_NAME + '/' + UPDATE_ITEM, {
        url: BASE_URL + '/' + this.$route.params.id,
        contents: formData,
        returnType: "stateless",
        acceptPromise: true,
      });

      this.$router.push({'name': 'company.questions.list'})

    },
    dragNdrop(event) {
      let file = event.target.files[0];
      this.form.media = file;

      this.preview = '<div class="file-info">' +
          '<div>' + this.$t('general.format') + ': <span>' +file.type+'</span></div>' +
          '<div>' + this.$t('general.document_name') + ': <span>' +file.name+'</span></div>' +
          '<div>' + this.$t('general.size') + ': <span>' + this.bytesToSize(file.size)+'</span></div>' +
          '</div><br>' +
          '<div><img src="'+URL.createObjectURL(file)+'" /></div>';

      this.form.media_is_url = false;
    },
    dragNdropReply(event) {
      let self = this;
      let file = event.target.files[0];
      let blob = URL.createObjectURL(file);
      let html = '<div class="file-info">' +
          '<div>' + this.$t('general.format') + ': <span>' +file.type+'</span></div>' +
          '<div>' + this.$t('general.document_name') + ': <span>' +file.name+'</span></div>' +
          '<div>' + self.$t('general.size') + ': <span>' + self.bytesToSize(file.size)+'</span></div>' +
          '</div><br>' +
          '<div><img src="'+blob+'" /></div>';

      $('.preview_' + event.target.getAttribute('data-index')).html(html);
      self.form.answers[event.target.getAttribute('data-index')].media = file;
    },
    dragNdropAudio(event){
      let self = this;
      let file = event.target.files[0];
      self.form.media = file;

      let html = '<div class="file-info">' +
          '<div>' + this.$t('general.format') + ': <span>' +file.type+' <i class="uil-microphone" style="font-size: 14px"></i></span></div>' +
          '<div>' + self.$t('general.audio_file_name') + ': <span>' +file.name+'</span></div>' +
          '<div>' + self.$t('general.size') + ': <span>' + self.bytesToSize(file.size)+'</span></div>' +
          '</div>';

      self.audioPreview = html;
    },
    dragNdropVideo(event){
      let self = this;
      let file = event.target.files[0];
      self.form.media = file;

      let html = '<div class="file-info">' +
          '<div>' + this.$t('general.format') + ': <span>' +file.type+' <i class="uil-video" style="font-size: 14px"></i></span></div>' +
          '<div>' + self.$t('general.video_file_name') + ': <span>' +file.name+'</span></div>' +
          '<div>' + self.$t('general.size') + ': <span>' + self.bytesToSize(file.size)+'</span></div>' +
          '</div>';

      self.videoPreview = html;
    },
    addRow(){
      this.form.answers.push({
        name: "",
        answer: false
      });
    },
    removeRow(index){
      this.form.answers.splice(index, 1);
    },
    questionTypeCheck(question_type){
      switch (question_type) {
        case 1 : return true;
        case 2 : return true;
        case 3 : return true;
        case 7 : return true;
        case 8 : return true;
      }
      return false;
    },
    formTypeControl(){
      this.form = {
        media_is_url: false,
        type : this.form.type,
        text : '',
        media : '',
        answers : [{name: "", answer:true}],
      }

      this.preview = null;
      this.previewReply = [];
      this.audioPreview = null;
      this.videoPreview = null;
      $("div[class^='preview_']").html("");
      $('input[type="file"]').val("");

      switch (this.form.type) {
        case 1 : this.answer_type = "text"; break;
        case 2 : this.answer_type = "text"; break;
        case 3 : this.answer_type = "text"; break;
        case 4 : this.answer_type = "image"; break;
        case 5 : this.answer_type = "image"; break;
        case 6 : this.answer_type = "text"; break;
        case 7 : this.answer_type = "audio"; break;
        case 8 : this.answer_type = "video"; break;
      }
    },
    getItem(){
      store.dispatch(MODULE_NAME + '/' + GET_ITEM, {
        url: BASE_URL + '/' + this.$route.params.id,
      })
    },
    getQuestionTypes(){
      store.dispatch(MODULE_NAME + '/' + GET_QUESTION_TYPES, {
        url: QUESTION_TYPE_URL,
      })
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: 'smooth'
      })
    }
  },
  mounted() {
    this.getItem();
    this.getQuestionTypes();
  },
  watch: {
    question_types(value) {
      if (value) {
        setTimeout(() => {
          $('.selectpicker').selectpicker();
        }, 100)
      }
    }
  }
}
</script>
<style scoped>
.uk-alert{
  margin: 0;
}
</style>
